export default {
    UPDATE_UPCOMING_EVENTS(state, data) {
        state.upcoming = data;
    },

    UPDATE_ATTENDED_EVENTS(state, data) {
        state.attended = data;
    },

    SET_PROCESSING_STATE(state, isProcessing) {
        state.isProcessing = isProcessing;
    }
}